<div class="container" xmlns="http://www.w3.org/1999/html">
  <div class="wrap">
    <h1 class="title restaurant-title">{{ 'pages.restaurantAccount.title' | translate }}</h1>
    <div class="account-grid">
      <div class="account-details">
    <form class="modal__form info"
          [formGroup]="restaurantInfo"
          (submit)="updateRestaurantInfo(restaurantInfo)"
    >
      <mat-form-field class="login-wrap__text">
        <mat-label>{{ 'pages.restaurantAccount.name' | translate }}</mat-label>
        <input matInput appFormInputTrim formControlName="name">
      </mat-form-field>

      <mat-form-field class="login-wrap__text">
        <mat-label>{{ 'pages.restaurantAccount.email' | translate }}</mat-label>
        <input readonly matInput appFormInputTrim formControlName="email">
      </mat-form-field>

      <mat-form-field class="login-wrap__text">
        <mat-label>{{ 'pages.restaurantAccount.address' | translate }}</mat-label>
        <input matInput appFormInputTrim formControlName="address">
      </mat-form-field>

      <mat-form-field class="login-wrap__text">
        <mat-label>{{ 'pages.restaurantAccount.phone' | translate }}</mat-label>
        <input matInput appFormInputTrim formControlName="contactPhone">
      </mat-form-field>

      <mat-form-field class="login-wrap__text">
        <mat-label>{{ 'pages.restaurantAccount.dwallGroupId' | translate }}</mat-label>
        <input matInput appFormInputTrim formControlName="dwallGroupId">
      </mat-form-field>

      <mat-form-field class="login-wrap__text">
        <mat-label>{{ 'pages.restaurantAccount.province' | translate }}</mat-label>
        <input matInput appFormInputTrim formControlName="province">
      </mat-form-field>

      <mat-form-field class="login-wrap__text">
        <mat-label>{{ 'pages.restaurantAccount.wifiName' | translate }}</mat-label>
        <input type="text" appFormInputTrim matInput formControlName="wifiName">
        <mat-error *ngIf="restaurantInfo.get('wifiName')?.errors?.maxlength && restaurantInfo.get('wifiName')?.touched">
          {{ 'pages.restaurantAccount.required50' | translate }}
        </mat-error>
        <mat-error *ngIf="restaurantInfo.controls.wifiName.errors?.required">
          {{ 'pages.restaurantAccount.wifiValidation' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="login-wrap__text">
        <mat-label>{{ 'pages.restaurantAccount.wifiPass' | translate }}</mat-label>
        <input type="text" matInput formControlName="wifiPassword">
        <mat-error *ngIf="restaurantInfo.get('wifiPassword')?.errors?.maxlength && restaurantInfo.get('wifiPassword')?.touched">
          {{ 'pages.restaurantAccount.required64' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="login-wrap__text">
        <mat-label>{{ 'pages.restaurantAccount.defaultLanguage' | translate }}</mat-label>
        <mat-select placeholder="{{ 'pages.restaurantAccount.selectLanguage' | translate }}" formControlName="language">
          <mat-option value="en-CA">
            {{ 'languages.en-CA.label' | translate }}
          </mat-option>
          <mat-option value="fr-CA">
            {{ 'languages.fr-CA.label' | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field *ngIf="canViewRestrictedData" class="login-wrap__text">
        <mat-label>{{ 'pages.restaurantAccount.status' | translate }}</mat-label>
        <mat-select formControlName="status">
          <mat-option [value]="null">
            {{ 'pages.restaurantAccount.statuses.notSet' | translate }}
          </mat-option>
          <mat-option *ngFor="let status of restaurantStatuses" [value]="status">
            {{ ('pages.restaurantAccount.statuses.' + status) | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field *ngIf="canViewRestrictedData" class="login-wrap__text">
        <mat-label>{{ 'pages.restaurantAccount.lastContactedAt' | translate }}</mat-label>
        <input
          matInput
          [matDatepicker]="lastContactedAtPicker"
          [max]="maxLastContactedAt"
          formControlName="lastContactedAt"
        >
        <button
          *ngIf="canEditRestrictedData && restaurantInfo.get('lastContactedAt')?.value"
          mat-icon-button
          matSuffix
          type="button"
          [attr.aria-label]="'pages.restaurantAccount.clearLastContactedAt' | translate"
          (click)="clearLastContactedAt()"
        >
          <mat-icon>close</mat-icon>
        </button>
        <mat-datepicker-toggle *ngIf="canEditRestrictedData" matSuffix [for]="lastContactedAtPicker"></mat-datepicker-toggle>
        <mat-datepicker #lastContactedAtPicker></mat-datepicker>
        <mat-error *ngIf="restaurantInfo.get('lastContactedAt')?.hasError('matDatepickerMax')">
          {{ 'pages.restaurantAccount.lastContactedAtFuture' | translate }}
        </mat-error>
      </mat-form-field>

      <ng-container *ngIf="isAvailable">
        <mat-form-field class="login-wrap__text">
          <mat-label>{{ 'pages.restaurantAccount.adRunEvery' | translate }}</mat-label>
          <input matInput appFormInputTrim formControlName="adRunEvery">
          <mat-error *ngIf="restaurantInfo.get('adRunEvery')?.errors && restaurantInfo.get('adRunEvery')?.touched">
            {{ 'pages.restaurantAccount.maxLengthValidation' | translate }}
          </mat-error>
        </mat-form-field>
      </ng-container>

      <div class="btn-wrap">
        <button class="btn btn__primary"
                type="submit"
                [disabled]="restaurantInfo.invalid || !restaurantInfo.dirty || !editable"
        >
          {{ 'pages.restaurantAccount.save' | translate }}
        </button>

        <button *ngIf="['chains', 'chain'].includes(auth.area()) && editable"
                class="btn btn__warning"
                type="button"
                (click)="confirmToRemoveRestaurant()"
        >
          {{ 'pages.restaurantAccount.deleteRestaurantTitle' | translate }}
        </button>
      </div>
    </form>

    <div class="qr-container" *ngIf="this.publicUrl">
      <h3>{{ 'pages.restaurantAccount.qrTitle' | translate }}</h3>
        <div class="qr__img">
          <qrcode class="qr"
                  id="qrElement"
                  [qrdata]="this.publicUrl"
                  [width]="160"
                  [errorCorrectionLevel]="'M'"
                  [margin]="0"
          ></qrcode>
          <div class="description">
            <div class="description__label">{{ 'pages.restaurantAccount.copyLink' | translate }}</div>
            <div
              class="link__container"
              (click)="copyLink()"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M17.5 14H19a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-7a2 2 0 0 0-2 2v1.5M5 10h7a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7c0-1.1.9-2 2-2Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span class="link">{{this.publicUrl}}</span>
            </div>
            <div class="description__label">{{ 'pages.restaurantAccount.orDownload' | translate }}</div>
            <button  *ngIf="isAvailable"
                     class="btn btn__secondary btn__icon"
                     (click)="downloadQr()"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="3 3 18 18" fill="none">
                <path d="M5.256 16A5.33 5.33 0 0 1 3 11.65C3 9.2 4.8 6.936 7.5 6.5 8.347 4.486 10.351 3 12.69 3c2.994 0 5.442 2.323 5.61 5.25 1.59.695 2.7 2.4 2.7 4.247a4.5 4.5 0 0 1-2 3.745M12 21V11m0 10-3-3m3 3 3-3" stroke="#ffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span class="add">{{ 'pages.restaurantAccount.download' | translate }}</span>
            </button>
          </div>
        </div>
    </div>
      </div>

      <aside *ngIf="canViewRestrictedData && restaurantId" class="comments-column">
        <app-restaurant-comments
          [restaurantId]="restaurantId"
          [canAdd]="canEditRestrictedData"
        ></app-restaurant-comments>
      </aside>
    </div>

    <app-restaurant-modems
      *ngIf="canViewRestrictedData && restaurantId"
      [restaurantId]="restaurantId"
      [editable]="canEditRestrictedData"
    ></app-restaurant-modems>
  </div>
</div>
